import { CapacityBadge, GuaranteeNote, Reveal, WhatsAppCta } from "@/components/brand";

export default function FinalCTA() {
  return (
    <section id="contato" data-testid="final-cta-section" className="px-4 pb-20 sm:px-6 md:pb-28 lg:px-8">
      <Reveal className="mx-auto max-w-7xl rounded-2xl bg-primary px-6 py-16 text-primary-foreground md:px-16 md:py-20">
        <div className="grid items-end gap-10 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <CapacityBadge inverse className="mb-6" />
            <h2 className="text-3xl font-bold tracking-[-0.03em] md:text-5xl">
              Seu site no ar em 7 dias<span className="text-accent">.</span>
            </h2>
            <p className="mt-5 max-w-[52ch] text-lg leading-relaxed text-white/80">
              Conte o objetivo do seu negócio. Você recebe escopo, prazo e valor antes de começar.
            </p>
            <GuaranteeNote inverse className="mt-6 max-w-[52ch]" />
          </div>
          <div className="lg:col-span-4 lg:text-right">
            <WhatsAppCta variant="inverse" location="final" data-testid="final-cta-whatsapp" />
            <p className="mt-3 text-sm text-white/70">
              Resposta no mesmo dia. Sem formulário, direto com o Bruno.
            </p>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
